import { withRouter } from 'react-router-dom'

const BusinessLayout = ({ children }) => {
  return children
}

export default withRouter(BusinessLayout)
